import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index'
import i18n from './i18n'
import ELEMENTUI from '@jdcloud/jelement-next'

Vue.use(ELEMENTUI)
Vue.config.productionTip = false

Vue.prototype.isMobile = /Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)

import '@/assets/css/style.css'
import '@/assets/css/iconfont.css'

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
